var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_69_138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.297417 21.779L10.5245 11.5518C10.8918 11.1229 11.5375 11.0728 11.9664 11.4403C12.3954 11.8077 12.4454 12.4533 12.078 12.8823C12.0437 12.9223 12.0064 12.9596 11.9664 12.9938L3.48823 21.4823H43.9773C44.5421 21.4823 45 21.9402 45 22.5051C45 23.07 44.5421 23.5278 43.9773 23.5278H3.48823L11.9664 32.006C12.3954 32.3734 12.4454 33.019 12.078 33.448C11.7105 33.877 11.065 33.927 10.636 33.5595C10.596 33.5253 10.5586 33.488 10.5245 33.448L0.297325 23.2209C-0.0991402 22.8221 -0.0991402 22.1779 0.297417 21.779Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_69_138"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 45 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftarrow);
export default __webpack_public_path__ + "static/media/leftarrow.bc3a72d7fb514a0593620901adb86dbd.svg";
export { ForwardRef as ReactComponent };